import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import { ReactComponent as LikeColoredSvg } from './assets/like-colored.svg';

const LikeColoredIcon = React.forwardRef((args, ref) => <SvgIcon component={LikeColoredSvg} ref={ref} {...args} />);

export default LikeColoredIcon;
